/**
 * Created by Swaniti-Initiative on 8/23/17.
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import "rxjs/add/operator/map";
import "rxjs/add/operator/mergeMap";
import { Observable } from 'rxjs/Observable';
import { RestApiConnection } from "../../classes/RestApiConnection.class";
import { NavigateUrlService } from "../services/navigate-url.service";
import * as XLSX from 'xlsx';
import { environment } from '../../../environments/environment';
import { BehaviorSubject } from 'rxjs';
declare var amplitude: any;


@Injectable()
export class RestApiService {
  http: HttpClient;
  router: Router;
  storageTokensData;
  orgName = new BehaviorSubject(localStorage.getItem('companyName'));
  goToSurveys = new BehaviorSubject(false);
  constructor(http: HttpClient, router: Router, private removeDataservice:NavigateUrlService) {
    this.http = http;
    this.router = router;
  }


  getRestApiConnection() {
    this.storageTokensData =  JSON.parse(localStorage.getItem('browserStorage'));
    let restApiConnection = new RestApiConnection();
    restApiConnection.Host = "http://localhost";
    // restApiConnection.Host = "http://swaniti.org";
    restApiConnection.port = 3000;
    // return (restApiConnection.Host + ":" + restApiConnection.port);
    return (environment.restApiServer);
  }

  loginRequestService(username, password) {
    return this.http.post<any>(this.getRestApiConnection() + '/checkAuth', { userName: username, passWord: password })
      .map(result => {
        if (result.loginResult.success == true) {
          amplitude.getInstance().logEvent('loginsuceessful', { "username": username });
          if (result.loginResult.tokens.superAdminIds != undefined) {
            // setting list of organisation along with its superadminId
            if(result.loginResult.tokens.superAdminIds){
              const loginId = result.loginResult.tokens.loginId;
              const superAdminId = result.loginResult.tokens.superAdminIds.superAdminIDs;
              const companyName = result.loginResult.tokens.superAdminIds.company_names;
              let switchOrg :{orgName:string,superAdminID:string}[]=[]
              let superAdminOrg:{orgName:string,superAdminID:string}[]= [];
              for (let index = 0; index < superAdminId.length; index++) {
                if(superAdminId[index]==loginId){
                  superAdminOrg.push({orgName : companyName[index],superAdminID:superAdminId[index]})
                }
                else{
                  switchOrg.push({orgName : companyName[index],superAdminID:superAdminId[index]});
                }
              }
              // appending the superadmin org at the very start if it also has owner superadminId
              if(superAdminOrg && superAdminOrg.length>0){
                switchOrg = [superAdminOrg[0],...switchOrg];
              }
              if(switchOrg && switchOrg.length>0){
                localStorage.setItem('switchOrg',JSON.stringify(switchOrg));
              }
            }

            let selfSuperAdmin = true;
            for (let i = 0; i < result.loginResult.tokens.superAdminIds.superAdminIDs.length; i++) {
              if (result.loginResult.tokens.loginId != (result.loginResult.tokens.superAdminIds.superAdminIDs[i]).replace(/'/g, "")) {
                localStorage.setItem("superAdminID", result.loginResult.tokens.superAdminIds.superAdminIDs[i]);
                selfSuperAdmin = false;
                break;
              }
            }
            if (selfSuperAdmin) {
              localStorage.setItem("superAdminID", result.loginResult.tokens.superAdminIds.superAdminIDs[0]);
            }
          }
          else {
            // localStorage.setItem("superAdminID", result.loginResult.tokens.); mahima
          }
          localStorage.setItem("user_name_header", result.loginResult.tokens.name);
        }
        else {
          amplitude.getInstance().logEvent('loginunsuceessful', { "username": username });
        }
        localStorage.setItem("username", username);
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          return (result);
        }
      });
  }

  surveyorLogInRequestService(username, password) {
    return this.http.post<any>(this.getRestApiConnection() + '/checkSurveyorAuth', { userName: username, passWord: password })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          return (result);
        }
      });
  }

  // deprecated
  // getSessionService(tokens) {
  //   return this.http
  //     .post<any>(this.getRestApiConnection() + '/getSession', { tokensData: tokens })
  //     .map(result => {
  //       if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
  //         this.router.navigateByUrl('/logIn');
  //       }
  //       else {
  //         this.storeTokensData( result);
  //         return (result);
  //       }
  //     });
  // }

  getQnrListService() {
    let superAdminID:any = localStorage.getItem('superAdminID');
    superAdminID=superAdminID.replaceAll("'","");
    let accessToken = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getQnrList', { 
        tokensData: this.storageTokensData, token:  accessToken, superAdminID:superAdminID })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  sendmailgstinvoice(email, place, customername, subscriptionid, gstinnumber, address) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/sendmailgstinvoice', { tokensData: this.storageTokensData, token:  token, email: email, place: place, customername: customername, subscriptionid: subscriptionid, gstinnumber: gstinnumber, address: address })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  convertToRepeat(qID, min, max) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/convertToRepeat', { tokensData: this.storageTokensData, token:  token, qID: qID, min: min, max: max })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  getLatLong(address) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getLatLong', { tokensData: this.storageTokensData, token:  token, address: address })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }
  createQnrService(accessToken, userInput) {
    userInput.token = accessToken;
    userInput['tokensData'] = this.storageTokensData;
    let superAdminID:any = localStorage.getItem('superAdminID');
    superAdminID=superAdminID.replaceAll("'","");
    userInput.superAdminID = superAdminID;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/createQnr', userInput)
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }
  getlocations(ID, teamID) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getlocations', { tokensData: this.storageTokensData, token:  token, qID: ID, teamID: teamID })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }
  setlocations(ID, details, lat, lng, teamID) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/setlocations', { tokensData: this.storageTokensData, token:  token, qID: ID, details: details, lat: lat, lng: lng, teamID: teamID })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  deletelocations(qID, teamID, index) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/deletelocations', { tokensData: this.storageTokensData, token:  token, qID: qID, teamID: teamID, index: index })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  getTemplateDetailsService(type) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getTemplateDetails', { tokensData: this.storageTokensData, token:  token, type: type })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  deleteTemplates(type) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/deleteTemplates', { tokensData: this.storageTokensData, token:  token, type: type })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  getRepeatedQuesData(surveyID, id, groupID, childIds) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getRepeatedQuesData', { tokensData: this.storageTokensData, token:  token, surveyID: surveyID, id: id, groupID: groupID, childIds: childIds })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  getExcelFile(surveyID, adminID, surveyName,version) {

    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    let req:any = { tokensData: this.storageTokensData, token:  token, adminIDs: adminID, 
      surveyIDs: surveyID, surveyName: surveyName };
    if(version){
      req.version = version;
    }
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/createCsv',req )
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  copyQnrService(accessToken, userInput) {
    userInput.token = accessToken;
    userInput['tokensData'] = this.storageTokensData;
    let superAdminID = localStorage.getItem('superAdminID');
    userInput.superAdminID =  superAdminID;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/copyQnr', userInput)
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  getDateLevelWiseSurveyCountService(surveyID, adminID, level, ques) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getDateLevelWiseSurveyCount', { tokensData: this.storageTokensData, token:  token, adminID: adminID, surveyID: surveyID, level: level, ques: ques })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }


  getSurveyerList(search,searchBy,orderSeq,orderby) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    let superAdminID = localStorage.getItem('superAdminID');
    let req:any = { tokensData: this.storageTokensData, token:  token, superAdminID: superAdminID}
    if(search){
      req.search = search;
    }
    if(searchBy){
      req.search_by = searchBy;
    }
    if(orderSeq){
      req.order_seq = orderSeq;
    }
    if(orderby){
      req.orderby = orderby;
    }
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getUserListWithDetails',req)
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  getDateUserWiseSurveyCount(adminId,surveyId,type,version,startDate,endDate,surveyorFilter){
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    let req:any= 
    { tokensData: this.storageTokensData, token:  token, adminID: adminId, surveyID: surveyId,
      type: type}
     if(version){
      req.version=version;
     }
     if(startDate){
      req.start_date=startDate;
     }
     if(endDate){
      req.end_date=endDate;
     }
     if(surveyorFilter){
      req.surveyor_filter=surveyorFilter;
     }
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getDateUserWiseSurveyCount',req)
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  getMapViewForSurvey(adminId,surveyId,version,startDate,endDate,surveyorFilter){
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    let req:any= 
    { tokensData: this.storageTokensData, token:  token, adminID: adminId, surveyID: surveyId}
     if(version){
      req.version=version;
     }
     if(startDate){
      req.start_date=startDate;
     }
     if(endDate){
      req.end_date=endDate;
     }
     if(surveyorFilter){
      req.surveyor_filter=surveyorFilter;
     }
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getMapViewForSurvey',req)
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  changePlan(superAdminID, planID) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/changePlan', { tokensData: this.storageTokensData, token:  token, superAdminID: superAdminID, planID: planID })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  getManagersList() {

    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getManagerList', { tokensData: this.storageTokensData, token:  token })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }
  removeManagerFromShare(email, qnrID) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/removeManagerFromShare', { tokensData: this.storageTokensData, token:  token, email: email, qnrID: qnrID })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  getListOfSurveyorsNotInTeam(teamID) {

    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    let superAdminID = localStorage.getItem('superAdminID');
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getListOfSurveyorsNotInTeam', { tokensData: this.storageTokensData, token:  token, teamID: teamID, superAdminID: superAdminID })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }
  getListOfSurveyorsForTeam(teamID) {

    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getListOfSurveyorsForTeam', { tokensData: this.storageTokensData, token:  token, teamID: teamID })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }
  editName(newTeamName, teamID) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/editNameOfTeam', { tokensData: this.storageTokensData, token:  token, teamID: teamID, Name: newTeamName })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  createNewSurveyer(phone) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    let superAdminID = localStorage.getItem('superAdminID');
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/createNewSurveyer', { tokensData: this.storageTokensData, token:  token, phone: phone, superAdminID: superAdminID })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }
  updateinvitesent(phone) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/updateinvitesent', { tokensData: this.storageTokensData, token:  token, userName: phone })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  createNewGroupService(groupName) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    let superAdminID:any = localStorage.getItem('superAdminID');
    superAdminID=superAdminID.replaceAll("'","");
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/createNewGroup', { 
        tokensData: this.storageTokensData, token:  token, groupName: groupName,
        superAdminID:superAdminID })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  setTeamForSurveyor(userName, teamName) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/setTeamForSurveyor', { tokensData: this.storageTokensData, token:  token, userName: userName, teamName: teamName })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  setMultipleTeamForMulipleSurveyor(phoneNos:string[],teamIds:string[]){
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/setTeamsForMulSurveyor', 
      { tokensData: this.storageTokensData, token:  token, phone_nos: phoneNos, teamids: teamIds })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }


  getSurveyorTeams(uid){
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    let superAdminID:any = localStorage.getItem('superAdminID');
    superAdminID=superAdminID.replaceAll("'","");
    return this.http
      .post<any>(this.getRestApiConnection() + '/getSurveyorTeams', 
      { token:  token, uid:uid, superAdminID:superAdminID })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  removeTeamForSurveyor(userName, teamName) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/removeTeamForSurveyor', { tokensData: this.storageTokensData, token:  token, userName: userName, teamName: teamName })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  uploadSurveyorCSV(dataCSV) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    let superAdminID = localStorage.getItem('superAdminID');
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/uploadSurveyorCSV', { tokensData: this.storageTokensData, token:  token, dataCSV: dataCSV, superAdminID: superAdminID })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });

  }
  getQnrExcel(surveyID, surveyName) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getQnrExcel', { tokensData: this.storageTokensData, token:  token, surveyID: surveyID, surveyName: surveyName })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  changeActivityStatus(surveyID, status) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/changeStatus', { tokensData: this.storageTokensData, token:  token, surveyID: surveyID, status: status })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  getGroupListWithDetailsForAdminService(qID) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    let superAdminID:any = localStorage.getItem('superAdminID');
    superAdminID=superAdminID.replaceAll("'","");
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getGroupListWithDetailsForAdmin', { tokensData: this.storageTokensData, token:  token ,superAdminID:superAdminID})
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }
  requestAdminSurveys(teamID) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    let superAdminID:any = localStorage.getItem('superAdminID');
    superAdminID=superAdminID.replaceAll("'","");
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getSurveyListForAdmin', { tokensData: this.storageTokensData, token:  token, teamID: teamID ,
      superAdminID:superAdminID})
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  getTeamListForAdminSurvey(qId:string){
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    let superAdminID:any = localStorage.getItem('superAdminID');
    superAdminID=superAdminID.replaceAll("'","");
    return this.http
      .post<any>(this.getRestApiConnection() + '/getTeamListForAdminSurvey', 
      { token:  token,superAdminID: superAdminID,qID: qId})
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  createTeamWithDetails(userId:string[],groupName:string,qNames:string[],qId:string[],
    areaDefined:{details:{name:string,radius:string,limit:string,responses:string}[],
                lat:string[],lng:string[],qID:string}[]){
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    let superAdminID:any = localStorage.getItem('superAdminID');
    superAdminID=superAdminID.replaceAll("'","");
    return this.http
      .post<any>(this.getRestApiConnection() + '/createTeamWithDetails', 
      { tokensData: this.storageTokensData, token:  token, userIDs:userId,groupName:groupName,
        Q_Names:qNames,Q_ids:qId,area_defined:areaDefined, superAdminID:superAdminID})
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  assignSurveysToGroupService(userIDs, groupName, Q_Names, Q_ids,adminID?) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    let superAdminID:any = localStorage.getItem('superAdminID');
    superAdminID=superAdminID.replaceAll("'","");
    let req:any =  { tokensData: this.storageTokensData, token:  token, 
      userIDs: userIDs, groupName: groupName, Q_Names: Q_Names, Q_ids: Q_ids , 
      superAdminID:superAdminID };
    if(adminID){
      req.adminID = adminID
    }
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/assignSurveysToGroup',req)
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  signUpService(userName, password, email, mobileNo, superAdminID, plan, companyName) {
    if (superAdminID == '') {
      return this.http
        .post<any>(this.getRestApiConnection() + '/signUp', { userName: email, name: userName, password: password, email: email, phone_number: mobileNo, plan: plan, companyName: companyName })
        .map(result => {
          if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
            this.clearDataOnRedirectLogIn();
            this.router.navigateByUrl('/logIn');
          }
          else {
            return (result);
          }
        });
    }
    else {
      return this.http
        .post<any>(this.getRestApiConnection() + '/signUp', { userName: email, name: userName, password: password, email: email, phone_number: mobileNo, superAdminID: superAdminID })
        .map(result => {
          if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
            this.clearDataOnRedirectLogIn();
            this.router.navigateByUrl('/logIn');
          }
          else {
            return (result);
          }
        });
    }
  }

  confirmSignUpService(userName, confirmationCode, planSelected) {
    return this.http
      .post<any>(this.getRestApiConnection() + '/confirmSignUp', { confirmationCode: confirmationCode, userName: userName, planSelected: planSelected })
      .map(result => {

        if (result.success == true) {
          if (result.superAdminIds != undefined) {
            localStorage.setItem("superAdminID", result.superAdminIds.superAdminIDs[result.superAdminIds.superAdminIDs.length - 1]);
          }
          else {
            // localStorage.setItem("superAdminID", result.loginResult.tokens.); mahima
          }
          localStorage.setItem("user_name_header", result.tokens.name);
          localStorage.setItem("username", result.tokens.email);
          console.log("responses confirSignup......",result)
        }
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          return (result);
        }
      });
  }

  getQnrWithDetailsService(Id) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getQnrWithDetails', { tokensData: this.storageTokensData, token:  token, Id: Id })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  updateQnrService(qID, qnr, anamoly, casLoc, status) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/updateQnr', { tokensData: this.storageTokensData, token:  token, qID: qID, qnr: qnr, anamoly: anamoly, casLoc: casLoc, status: status })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  publishGroupedForm(qID) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/publishGroupedForm', { tokensData: this.storageTokensData, token:  token, qID: qID})
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  forgotPasswordService(userName) {
    return this.http
      .post<any>(this.getRestApiConnection() + '/forgotPassword', { userName: userName })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          return (result);
        }
      });
  }
  confirmForgotPassword(userName, passsword, code) {
    return this.http
      .post<any>(this.getRestApiConnection() + '/confirmForgotPassword', { userName: userName, passsword: passsword, confirmationCode: code })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          return (result);
        }
      });
  }
  //id is array of json
  removeSurveyerService(id, uID) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/removeUsers', { tokensData: this.storageTokensData, token:  token, id: id, uID: uID })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  deleteGroupService(groupNames) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/deleteGroup', { tokensData: this.storageTokensData, token:  token, groupNames: groupNames })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  deleteQnr(qnrID, qnrName, type) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/deleteQnr', { tokensData: this.storageTokensData, token:  token, qnr: qnrID, qnrName: qnrName, src: "sm", type: type })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });

  }
  editQnrService(qID, userInput) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/editQnr', { tokensData: this.storageTokensData, token:  token, qID: qID, userInput })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });

  }

  inviteSurveyerService(userName) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/inviteSurveyer', { tokensData: this.storageTokensData, token:  token, userName: userName })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });

  }
  shareQnr(email, qnrID) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    let superAdminID:any = localStorage.getItem('superAdminID');
    superAdminID=superAdminID.replaceAll("'","");
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/shareQnr', { 
        tokensData: this.storageTokensData, token:  token, email: email, qnrID: qnrID,
      superAdminID:superAdminID })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });

  }
  getSurveyDataService(surveyID, ques, adminID, option, operation) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getSurveyData', { tokensData: this.storageTokensData, token:  token, surveyID: surveyID, ques: ques, adminID: adminID, option: option, operation: operation })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  inviteManagerService(email) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/inviteManager', { tokensData: this.storageTokensData, token:  token, email: email })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });

  }

  getadminStatus() {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getadminStatus', { tokensData: this.storageTokensData, token:  token })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          if(result && result.length>0){
            localStorage.setItem('companyName',result[0].company_name);
          }
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  setadminStatus(superAdmin) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/setadminStatus', { tokensData: this.storageTokensData, token:  token, superAdmin: superAdmin })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  declineInviteRequestforManager(superAdmin) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/declineInviteRequestforManager', { tokensData: this.storageTokensData, token:  token, Admin: superAdmin })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  checkIfSuperAdmin() {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    let superAdminID:any = localStorage.getItem('superAdminID');
    superAdminID=superAdminID.replaceAll("'","");
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/checkIfSuperAdmin', { tokensData: this.storageTokensData, token:  token,
        superAdminID: superAdminID})
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  removeAdminforSuperadmin(adminID) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    let superAdminID = JSON.parse(localStorage.getItem('browserStorage')).superAdminID
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/removeAdminforSuperadmin', { tokensData: this.storageTokensData, token:  token, adminID: adminID, superAdminID: superAdminID })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  getSurveyDataServicePage(surveyID, adminID, page, numberofrows, childIDs, searchTerm) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    let superAdminID = localStorage.getItem('superAdminID');
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getSurveyDataPage', { tokensData: this.storageTokensData, token:  token, adminID: adminID, surveyID: surveyID, page: page, numberofrows: numberofrows, childIDs: childIDs, superAdminID: superAdminID, 'type': 'userName', 'searchTerm': searchTerm })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });

  }

  getSurveyDataForID(surveyID, adminID, id) {

    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getSurveyDataForID', { tokensData: this.storageTokensData, token:  token, adminID: adminID, surveyID: surveyID, id: id })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });

  }

  getSurveyDataServicePageWithFilter(postparams) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    postparams['token'] = token;
    postparams['tokensData'] = this.storageTokensData;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getSurveyDataPageWithFilter', postparams)
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });

  }

  getSurveyDataWithDetails(postparams) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    postparams['token'] = token;
    postparams['tokensData'] = this.storageTokensData;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getSurveyDataWithDetails', postparams)
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });

  }


  getDateUserWiseSurveyCountService(surveyID, adminID, typeParam) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getDateUserWiseSurveyCount', { tokensData: this.storageTokensData, token:  token, adminID: adminID, surveyID: surveyID, type: typeParam })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  signOutService() {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/signout', { tokensData: this.storageTokensData, token:  token })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          // this.storeTokensData(result); --  doesn't make sense to set new tokens in local storage
          return (result);
        }
      });
  }

  getUserTemplates() {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    var superAdminID = localStorage.getItem("superAdminID");
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getUserTemplates', { tokensData: this.storageTokensData, token:  token, "superAdminID": superAdminID })
      .map(result => {
        amplitude.getInstance().logEvent('CreateNewFormClicked');
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  getAdminNames(adminIDs) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getAdminNames', { tokensData: this.storageTokensData, token:  token, adminIDs: adminIDs })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  makeTemplate(qnr, anamoly, casLoc, name, desc) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/makeTemplate', { tokensData: this.storageTokensData, token:  token, qnr: qnr, anamoly: anamoly, casLoc: casLoc, name: name, desc: desc })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  assignSurveyOnSignUp(uID) {

    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/assignSurveyOnSignUp', { uID: uID })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          return (result);
        }
      });
  }

  translateText(text, source, target) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/translateText', { tokensData: this.storageTokensData, token:  token, text: text, source: source, target: target })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });

  }

  definedAreasForSurvey(qID) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;

    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/getAllLocations', { tokensData: this.storageTokensData, token:  token, qID: qID })
      .map(result => {
        amplitude.getInstance().logEvent('locationsbuttonpressed');
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  updatechildgroupservice(ID, child_group) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;

    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/updatechildgroup', { tokensData: this.storageTokensData, token:  token, ID: ID, child_group: child_group })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  getAllPlansData() {
    return this.http
      .post<any>(this.getRestApiConnection() + '/getAllPlansData', {})
      .map(result => {
          return (result);
      });
  }

  getPlanAndAccountDetailsOfUser() {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    let superAdminID = localStorage.getItem('superAdminID');
    return this.http
      .post<any>(this.getRestApiConnection() + '/getPlanAndAccountDetailsOfUser', { tokensData: this.storageTokensData, token:  token,superAdminID:superAdminID })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  updateUserInfo(name, email, phone_number, image,companyName) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/updateUserInfo', { tokensData: this.storageTokensData, token:  token, Name: name, email: email, phone_number: phone_number, imageUrl: image,
        org_name:companyName })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  confirmMailUpdate(userName, confirmationCode) {
    let token;
    if (userName) {
      token = userName;
    }
    else {
      token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    }
    return this.http
      .post<any>(this.getRestApiConnection() + '/confirmMailUpdate', { tokensData: this.storageTokensData, token:  token, confirmationCode: confirmationCode })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  changePasswordOfUser(oldPass, newPass) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/changePasswordOfUser', { tokensData: this.storageTokensData, token:  token, old: oldPass, new: newPass })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  getFormInfoAndQuestions(Id) {
    // let tokenJson = localStorage.getItem('surveyorToken');
    // if (Boolean(tokenJson)) {
      return this.http
        .post<any>(this.getRestApiConnection() + '/getFormInfoAndQuestions', { Id: Id })
        .map(result => {
            return (result);
        });
    // }
    // else {
      // return Observable.of({ success: false });
    // }
  }

  onPaymentSuccess(planID, razorpay_payment_id, superAdminID, amountPaid, company_name, address, razorpay_subscription_id, oldSubscriptionID, itemID) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;

    return this.http
      .post<any>(this.getRestApiConnection() + '/onPaymentSuccess', { tokensData: this.storageTokensData, token:  token, planID: planID, razorpay_payment_id: razorpay_payment_id, superAdminID: superAdminID, amountPaid: amountPaid, company_name: company_name, address: address, razorpay_subscription_id: razorpay_subscription_id, oldSubscriptionID: oldSubscriptionID, itemID: itemID })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  syncQnrData(syncData) {
    return this.http
      .post<any>(this.getRestApiConnection() + '/syncQnrData', syncData)
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          return (result);
        }
      });

  }

  getUserCheckoutDetails() {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/getUserCheckoutDetails', { tokensData: this.storageTokensData, token:  token })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  getBillingDetails() {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/getBillingDetails', { tokensData: this.storageTokensData, token:  token })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }


  getgstDetails() {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/getgstDetails', { tokensData: this.storageTokensData, token:  token })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }




  updatebillinginfo(company_name, address) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/updatebillinginfo', { tokensData: this.storageTokensData, token:  token, company_name: company_name, address: address })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  updategstdetails(place, gstinnumber) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/updategstdetails', { tokensData: this.storageTokensData, token:  token, gstinnumber: gstinnumber, place: place })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  deleteAccount() {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/deleteAccount', { tokensData: this.storageTokensData, token:  token })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  sendVerificatiopnCodeOnMail(token) {

    return this.http
      .post<any>(this.getRestApiConnection() + '/sendVerificatiopnCodeOnMail', { tokensData: this.storageTokensData, token:  token })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  getAggDataForAnalyticsService(surveyID, adminID, childIDs, version) {
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/aggregateResponses', { tokensData: this.storageTokensData, token:  token, adminID: adminID, surveyID: surveyID, childIDs: childIDs, version: version })
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  getCurrentPlanAndFreePlanDetails(){
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
    .post<any>(this.getRestApiConnection() + '/getCurrentPlanAndFreePlanDetails', { tokensData: this.storageTokensData, token:  token })
    .map(result => {
      if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
        this.clearDataOnRedirectLogIn();
        this.router.navigateByUrl('/logIn');
      }
      else {
        this.storeTokensData(result);
        return (result);
      }
    });   
  }

  setUpdateProgress(status){
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/questionnaireAPI/setUpdateProgress', { tokensData: this.storageTokensData, token:  token, updateProgress: status})
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  checkForRedirectionToLogin(result) {
    if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
      return false;
    }
    else {
      return true;
    }
  }

  storeTokensData(updatedTokens){
      // //set the tokens again in local storage
      // let storageData = {
      //   accessToken: result.tokens.accessToken,
      //   refreshToken: result.tokens.refreshToken,
      //   idToken:result.tokens.idToken
      // };
      // localStorage.removeItem('browserStorage');
      // localStorage.setItem('browserStorage', JSON.stringify(storageData));

    if(updatedTokens.newTokens)
    {
      localStorage.removeItem('browserStorage');
      localStorage.setItem('browserStorage', JSON.stringify(updatedTokens.newTokens));
    }
  }

  clearDataOnRedirectLogIn(){
    this.removeDataservice.removeStorageData();
  }

  // getting list of manager invitations for a particular manager.
  getManagerInvitationsList(){
    let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
    return this.http
      .post<any>(this.getRestApiConnection() + '/getManagerInvitationsList', { token:  token})
      .map(result => {
        if (result.success == false && result.msg == 'REDIRECT_LOGIN') {
          this.clearDataOnRedirectLogIn();
          this.router.navigateByUrl('/logIn');
        }
        else {
          this.storeTokensData(result);
          return (result);
        }
      });
  }

  transformDate1(date:string){
    let month = [{month:'Jan',value:'01'},{month:'Feb',value:'02'},{month:'Mar',value:'03'},
    {month:'Apr',value:'04'},{month:'May',value:'05'},{month:'Jun',value:'06'},{month:'Jul',value:'07'}
    ,{month:'Aug',value:'08'},{month:'Sep',value:'09'},{month:'Oct',value:'10'},{month:'Nov',value:'11'}
    ,{month:'Dec',value:'12'}];
    if(date && date.length >=21){
      let selectedMonth:any = date.substring(4, 7);
      selectedMonth = month.find(data=>data.month == selectedMonth).value;
      const selectedDay = date.substring(8,10);
      const selectedYear = date.substring(11,15);
      const time = date.substring(16,21);
      const newDate = selectedDay + '/' +selectedMonth + '/' + selectedYear + " " + time;
      return newDate;
    }
    return '';
  }


  getSwitchOrgList():{orgName:string,superAdminID:string}[]{
    const switchOrgList = localStorage.getItem('switchOrg');
    if(switchOrgList && switchOrgList != undefined && switchOrgList != 'undefined'){
      return JSON.parse(switchOrgList);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/restApiServices/restapi.service.ts